import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from '@chakra-ui/react';
import { ArticleListNav } from '@src/components/sco/Education/ArticleListNav';
import { ContentTrackNav } from '@src/components/sco/Education/CourseTrackNav';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { EducationSidebarCollapsingNavList } from '@src/components/sco/Education/EducationSidebarCollapsingNavList';
import { PodcastListNav } from '@src/components/sco/Education/PodcastListNav';
import { SinglePlaybookNav } from '@src/components/sco/Education/SinglePlaybookNav';
import { VideoLessonsListNav } from '@src/components/sco/Education/VideoLessonsListNav';
import { LexiconSidebarNav } from '@src/components/sco/LexiconSidebarNav';
import { TaxonomyTermCheckboxList } from '@src/components/sco/TaxonomyTermCheckboxList';
import { useParams } from 'next/navigation';
import React, { useMemo } from 'react';
type EducationNavProps = {};
export const EducationNav: React.FC<EducationNavProps> = props => {
  const $ = _c(37);
  const educationContext = useEducationContext();
  const routeParams = useParams();
  const sectionRoot = educationContext.activeSectionParts[0];
  routeParams?.contentTrackSlug;
  let t0;
  bb0: {
    if (educationContext.activeSection === "education.landing") {
      t0 = false;
      break bb0;
    }
    if (sectionRoot === "courses" && !routeParams?.contentTrackSlug) {
      t0 = false;
      break bb0;
    }
    t0 = true;
  }
  const sectionListCollapsed = t0;
  let t1;
  if ($[0] !== sectionListCollapsed) {
    t1 = <EducationSidebarCollapsingNavList collapsed={sectionListCollapsed} />;
    $[0] = sectionListCollapsed;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== routeParams || $[3] !== sectionRoot) {
    t2 = sectionRoot === "playbooks" && routeParams?.playbookSlug && <SinglePlaybookNav playbookSlug={`${routeParams.playbookSlug}`} />;
    $[2] = routeParams;
    $[3] = sectionRoot;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== educationContext || $[6] !== routeParams?.articleSlug || $[7] !== sectionRoot) {
    t3 = sectionRoot === "articles" && (routeParams?.articleSlug ? <ArticleListNav articleType="ExpertAdvice" keywords={educationContext.activeKeywords} termSlugs={educationContext.activeTerms.map(_temp)} typeSlug="articles" typeTitle="Articles" /> : <TaxonomyTermCheckboxList containerProps={{
      padding: "1em"
    }} selectedTermSlugs={educationContext.activeTermsSlugs} onChange={selectedTerms => {
      educationContext.setActiveTerms(selectedTerms);
    }} />);
    $[5] = educationContext;
    $[6] = routeParams?.articleSlug;
    $[7] = sectionRoot;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== sectionRoot) {
    t4 = sectionRoot === "lexicon" && <Box fontSize="1rem" paddingY={2}><LexiconSidebarNav /></Box>;
    $[9] = sectionRoot;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== educationContext || $[12] !== routeParams?.slug || $[13] !== sectionRoot) {
    t5 = sectionRoot === "founder-interviews" && (routeParams?.slug ? <ArticleListNav articleType="FounderStory" keywords={educationContext.activeKeywords} termSlugs={educationContext.activeTerms.map(_temp2)} typeSlug="founder-interviews" typeTitle="Founder Interviews" /> : <TaxonomyTermCheckboxList containerProps={{
      padding: "1em"
    }} selectedTermSlugs={educationContext.activeTermsSlugs} onChange={selectedTerms_0 => {
      educationContext.setActiveTerms(selectedTerms_0);
    }} />);
    $[11] = educationContext;
    $[12] = routeParams?.slug;
    $[13] = sectionRoot;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== educationContext || $[16] !== routeParams?.slug || $[17] !== sectionRoot) {
    t6 = sectionRoot === "podcast" && (routeParams?.slug ? <PodcastListNav keywords={educationContext.activeKeywords} termSlugs={educationContext.activeTerms.map(_temp3)} /> : <TaxonomyTermCheckboxList containerProps={{
      padding: "1em"
    }} selectedTermSlugs={educationContext.activeTermsSlugs} onChange={selectedTerms_1 => {
      educationContext.setActiveTerms(selectedTerms_1);
    }} />);
    $[15] = educationContext;
    $[16] = routeParams?.slug;
    $[17] = sectionRoot;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== educationContext || $[20] !== routeParams?.videoListSlug || $[21] !== sectionRoot) {
    t7 = sectionRoot === "videos" && (routeParams?.videoListSlug ? <VideoLessonsListNav /> : <TaxonomyTermCheckboxList containerProps={{
      padding: "1em"
    }} selectedTermSlugs={educationContext.activeTermsSlugs} onChange={selectedTerms_2 => {
      educationContext.setActiveTerms(selectedTerms_2);
    }} />);
    $[19] = educationContext;
    $[20] = routeParams?.videoListSlug;
    $[21] = sectionRoot;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== routeParams?.contentTrackSectionSlug || $[24] !== routeParams?.contentTrackSlug || $[25] !== routeParams?.contentTrackStepSlug || $[26] !== sectionRoot) {
    t8 = sectionRoot === "courses" && routeParams?.contentTrackSlug && <ContentTrackNav contentTrackSectionSlug={`${routeParams?.contentTrackSectionSlug}`} contentTrackSlug={`${routeParams?.contentTrackSlug}`} contentTrackStepSlug={`${routeParams?.contentTrackStepSlug}`} />;
    $[23] = routeParams?.contentTrackSectionSlug;
    $[24] = routeParams?.contentTrackSlug;
    $[25] = routeParams?.contentTrackStepSlug;
    $[26] = sectionRoot;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t1 || $[29] !== t2 || $[30] !== t3 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8) {
    t9 = <VStack align="stretch" gap={0} height="full" justify="stretch" overflow="auto" width="full">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</VStack>;
    $[28] = t1;
    $[29] = t2;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  return t9;
};
function _temp(term) {
  return term.slug;
}
function _temp2(term_0) {
  return term_0.slug;
}
function _temp3(term_1) {
  return term_1.slug;
}